import { useMediaQuery } from '@mui/material'
import cx from 'classnames'

import Rating from '@f/components/StarRating/StarRating'

import { usePageHeader } from '@f-fertighaus/layout/PageHeader/SSR/PageHeaderSSR'

export const StarRating = () => {
  const { domain } = usePageHeader()
  return {
    massivhaus: <CommonStarRating />,
    bungalow: <CommonStarRating />,
    fertighaus: <CommonStarRating />,
    einfamilienhaus: <EinfamilienhausStarRating />,
    bauen: <CommonStarRating />,
    immowelt: <CommonStarRating />,
    immonet: <CommonStarRating />
  }[domain || 'fertighaus']
}

const CommonStarRating = () => {
  const { appearance } = usePageHeader()
  const isMobileView = useMediaQuery('(max-width: 767px)')

  const showLightVersion =
    appearance === 'logo_with_rating_light' && isMobileView

  return (
    <div
      className={cx(
        '[ f-p-v-010 ] HLP-header-USPs',
        showLightVersion ? 'f-c-fo-pri' : 'f-c-fo-whi'
      )}>
      <span className='[ f-pos-rel f-d-inbl f-m-r-010 f-hidden:s ] HLP-hero-rating-stars'>
        Kundenbewertung:
      </span>
      <Rating backgroundType={showLightVersion ? 'light' : 'dark'} />
      <span className='[ f-pos-rel f-d-inbl ] HLP-hero-rating-stars'>
        4.5/5
      </span>
    </div>
  )
}

const EinfamilienhausStarRating = () => {
  return (
    <div className='[ f-p-v-010 ] HLP-header-USPs f-c-fo-pri'>
      <span className='[ f-pos-rel f-d-inbl f-m-r-010 f-hidden:s ] HLP-hero-rating-stars'>
        Kundenbewertung:
      </span>
      <Rating backgroundType='dark' />
      <span className='[ f-pos-rel f-d-inbl f-hidden:s ] HLP-hero-rating-stars'>
        4.5/5
      </span>
    </div>
  )
}
